<script lang="ts">
  import Dialog from "components/Common/Dialog.svelte";
  import {
    useDeleteCollectionMutation,
    removeCollectionFromCache,
    displayName,
  } from "./collectionOperations";
  import { useQueryClient } from "@tanstack/svelte-query";
  import { whoami, user } from "../../services/api";
  import { removeUserFromCollection } from "services/collections/api";
  import { orgFolder } from "@nrk/origo";
  import { notify } from "services/notifications";
  import { escapeHtml } from "utils/fns";
  export let collection;

  const queryClient = useQueryClient();

  const deleteCollectionMutation = useDeleteCollectionMutation();

  let currentUser = whoami();
  $: collectionOwner = collection ? user(collection?.owner) : null;
  async function onConfirm() {
    await $deleteCollectionMutation.mutateAsync(collection.id);
  }

  async function onRemoveAccess(userId: string) {
    try {
      await removeUserFromCollection(collection.id, userId);
    } catch {
      notify(`Kunne ikke fjerne tilgangen til ${escapeHtml(displayName(collection))}`, "error");
      return;
    }
    notify(`Fjernet tilgangen til ${escapeHtml(displayName(collection))}`, "success");
    removeCollectionFromCache(queryClient, collection.id);
  }
</script>

{#if collection}
  {#await currentUser then resolvedUser}
    {#if resolvedUser.id === collection.owner}
      <Dialog
        id="delete-collection-dialog"
        headerText={"Slett samling"}
        confirmText={"Slett"}
        {onConfirm}
      >
        <h3>Slett samling {displayName(collection)}</h3>
        <p>
          Du er i ferd med å slette <strong>{displayName(collection)}</strong>. Dette vil slette
          samlingen men ikke de tilhørige bildene, denne handlingen kan ikke angres.
        </p>
        {#if collection.visibleTo?.users?.length}
          <p>
            Samlingen deles med andre brukere, disse vil miste tilgangen til samlingen hvis den
            slettes.
          </p>
        {/if}
      </Dialog>
    {:else if resolvedUser.id !== collection.owner}
      <Dialog
        id="delete-collection-dialog"
        headerText={"Slett samling"}
        confirmText={"Fjern samling"}
        onConfirm={() => onRemoveAccess(resolvedUser.id)}
      >
        <p>Samlinger under kan ikke slettes fordi de tilhører andre brukere.</p>
        <div class="folder-list">
          <span class="folder-icon">{@html orgFolder}</span>
          <span>{displayName(collection)}</span>
          {#await collectionOwner then resolvedOwner}
            {#if resolvedOwner}
              <span class="folder-owner">{resolvedOwner.givenName} {resolvedOwner.familyName}</span>
            {/if}
          {/await}
        </div>
        <svelte:fragment slot="toolbar-buttons-right">
          <button type="button" disabled class="org-button org-button--suggestive"> Slett </button>
        </svelte:fragment>
      </Dialog>
    {/if}
  {:catch error}
    <p>{error.message}</p>
  {/await}
{/if}

<style>
  .folder-list {
    display: flex;
    align-items: center;
    gap: var(--org-medium);
    padding: var(--org-small);
    font-size: var(--org-font-2medium);
    color: var(--org-color-shade-2);
  }
  .folder-owner {
    font-size: var(--org-font-medium);
  }
  .folder-icon {
    display: inline-block;
    padding: var(--org-small);
    color: var(--org-color-shade-2);
    background: var(--org-color-gray-600);
  }
</style>
